<template>
  <div style="width: 100%; display: flex; margin-bottom: 8px">
    <el-button @click="dialogObject=true">+ Импорт из excel</el-button>
    <el-dialog v-loading="loader" title="Прикрепить excel файл" :visible.sync="dialogObject">
      <div     v-if="uploadValue === null" style="display: flex; flex-direction: column; align-items: center">
        <el-upload
          style="margin-bottom: 20px"
          list-type="picture"
          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          :http-request="onUpload"
          class="upload-demo"
          action="/"
          :show-file-list="false"
          drag
          multiple
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">Перетащите файл сюда или <br/><em>нажмите, чтобы загрузить</em></div>
        </el-upload>
        <el-checkbox v-model="remove">Удалить существующих работников</el-checkbox>
      </div>
      <el-progress v-else :percentage="uploadValue"></el-progress>

      <!--      <a href="/static/template-objects.xlsx">-->
      <!--        <el-button type="primary" @click="dialogObject = false">Скачать шаблон</el-button>-->
      <!--      </a>-->
        <el-button type="primary" @click="importFromExcel" style="margin-top: 20px">Выгрузка excel</el-button>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogObject = false">Ok</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import firebase from 'firebase';
import {apiUrl} from "../../../../plugins/firebase";
import {downloadURI} from "../../../../utils/urlUtils";
import dayjs from "dayjs";
import TabelProxy from "../../../../proxy/TabelProxy";

const proxy = new TabelProxy()

export default {
  name: 'ImportFromExcelCompany',
  data() {
    return {
      dialogObject: false,
      uploadValue: null,
      loader: false,
      remove: false,
      step: 0,
    };
  },
  computed: {
    dirUrl() {
      if (this.$store.state.project.version && this.$store.state.project.version.id) {
        const params = `/onGenerateTemplateZones/${this.$store.state.project.id}`
        return `${apiUrl}${params}`;
      }
      const params = `/onGenerateTemplateDirectivePlan/${this.$store.state.project.id}`
      return `${apiUrl}${params}`;
    }
  },
  methods: {
    async importFromExcel() {
      this.loader = true
      await downloadURI(proxy.getUsersFromExcel(this.$store.state.project.id, this.$route.params.id), 'usersCompany.xlsx', proxy.headers)
      this.dialogObject = false
      this.loader = false
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          resolve(reader.result);
        };
        reader.onerror = function (error) {
          reject('Error: ', error);
        };
      });
    },
    async onUpload(e) {
      // const imageData = await this.getBase64(e.file);
      this.loader = true;

      const response = await proxy.importFromExcel({
        file: e.file,
        companyId: this.$route.params.id,
        projectId: this.$store.state.project.id,
        deleteEmployees: this.remove,
      })


      if(response.status !== 'error') {
        this.$notify({
          title: 'Успешно!',
          message: 'Работники загружены',
          type: 'success',
        });
      } else  {
        this.$notify({
          title: 'Произошла ошибка',
          message: 'Файл загрузки не соответствует шаблону',
          type: 'error',
        });
      }

      this.loader = false;
      //
      // const proxy = authFirestorefunctions().httpsCallable('onParsePlanDirective');
      // proxy(
      //   {
      //     plan: imageData,
      //     projectId: this.$store.state.project.id,
      //   },
      // ).then((response) => {
      //   this.$notify({
      //     title: 'Успешно!',
      //     message: 'Объекты загружены',
      //     type: 'success',
      //   });
      //   this.dialogObject = false;
      //   this.$emit('update')
      // }).catch((error) => {
      //   this.$notify({
      //     title: 'Произошла ошибка',
      //     message: 'Файл загрузки не соответствует шаблону',
      //     type: 'error',
      //   });
      // }).finally(() => {
      //   this.loader = false;
      // });
    },
    save() {
      this.$emit('update');
      this.close();
    },
    close() {
      this.dialogObject = false;
    },
  },
};
</script>

<style lang="scss">
.upload-demo {
  margin: 0 auto;
  width: calc(100% - 20px);

  .el-upload {
    width: 100%;
  }

  .el-upload-dragger {
    width: 100%;
  }
}

.el-upload--picture {
  display: flex;
  justify-content: center;
}

.el-loading-mask {
  position: fixed !important;
  background-color: rgba(255, 255, 255, .4) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Users/company/ImportFromExcelCompany.vue